<template>
    <div class="vertical-scroll-layout">
        <slot></slot>
        <template v-for="row,idx in rows">
            <VSLSectionRowRenderer :key="`${row.id}_${idx}`" v-if="row.type == 'section'" :text="row.text" />
            <VSLLabelRowRenderer :key="`${row.id}_${idx}`" v-if="row.type == 'label'" :label="row.label" :value="row.value" :valueType="row.valueType" />
            <VSLLabelRowRenderer :key="`${row.id}_${idx}`" v-if="row.type == 'text_input'" :label="row.label" :value="row.value" valueType="text" />
            <VSLLabelRowRenderer :key="`${row.id}_${idx}`" v-if="row.type == 'single_select'" :label="row.label" :value="row.value" valueType="text" />
            <VSLLabelRowRenderer :key="`${row.id}_${idx}`" v-if="row.type == 'timestamp'" :label="row.label" :value="row.value" valueType="timestamp" />
            <VSLImageGalleryRowRenderer :key="`${row.id}_${idx}`" v-if="row.type == 'images'" :imagesUrls="row.imagesUrls" />
            <VSLHtmlRowRenderer :key="`${row.id}_${idx}`" v-if="row.type == 'html'" :label="row.label" :value="row.value" />
        </template>
    </div>
</template>

<script>
import VSLSectionRowRenderer from '@/views/ui/verticalScrollLayout/renderer/VSLSectionRowRenderer';
import VSLLabelRowRenderer from '@/views/ui/verticalScrollLayout/renderer/VSLLabelRowRenderer';
import VSLImageGalleryRowRenderer from '@/views/ui/verticalScrollLayout/renderer/VSLImageGalleryRowRenderer';
import VSLHtmlRowRenderer from '@/views/ui/verticalScrollLayout/renderer/VSLHtmlRowRenderer';

export default {
    name: "VerticalScrollLayout",

    components: {
        VSLSectionRowRenderer,
        VSLLabelRowRenderer,
        VSLImageGalleryRowRenderer,
        VSLHtmlRowRenderer
    },

    props: {
        rows: null
    }
}
</script>

<style scoped>
.vsl-row {
    border-bottom: 1px solid #dddddd;
    padding-left: 8px;
    padding-right: 8px;
    padding-bottom: 8px;
    margin-bottom: 8px;
    text-align: left;
}

.vsl-row-no-separator {
    padding-bottom: 8px;
    margin-bottom: 8px;
}
</style>
